var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmergencyReleaseButton01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.06,14.03H2.94V3.92h10.13V14.03z M3.44,13.53h9.13V4.42H3.44V13.53z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7.75,
    y: 1.27,
    className: "st2",
    width: 0.5,
    height: 2.91
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M5.27,7.01C5.5,6.97,5.8,6.94,6.18,6.94c0.47,0,0.81,0.11,1.03,0.31c0.2,0.17,0.32,0.44,0.32,0.77 c0,0.33-0.1,0.59-0.28,0.79C6.99,9.06,6.59,9.2,6.12,9.2c-0.14,0-0.27,0-0.38-0.03v1.47H5.27V7.01z M5.74,8.78 c0.1,0.03,0.23,0.04,0.39,0.04c0.57,0,0.92-0.28,0.92-0.78c0-0.49-0.34-0.72-0.87-0.72c-0.21,0-0.37,0.02-0.45,0.04V8.78z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.71,7.01c0.21-0.04,0.53-0.08,0.87-0.08c0.47,0,0.78,0.08,1.01,0.27c0.19,0.14,0.3,0.36,0.3,0.65 c0,0.35-0.23,0.66-0.62,0.81v0.01c0.35,0.09,0.76,0.38,0.76,0.92c0,0.32-0.13,0.56-0.31,0.74c-0.26,0.23-0.67,0.34-1.27,0.34 c-0.33,0-0.58-0.02-0.74-0.04V7.01z M9.18,8.52h0.43c0.5,0,0.79-0.26,0.79-0.62c0-0.43-0.33-0.6-0.81-0.6 c-0.22,0-0.34,0.02-0.42,0.03V8.52z M9.18,10.27c0.09,0.02,0.23,0.02,0.4,0.02c0.49,0,0.94-0.18,0.94-0.71 c0-0.5-0.43-0.71-0.95-0.71H9.18V10.27z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencyReleaseButton01);
export default __webpack_public_path__ + "static/media/EmergencyReleaseButton-01.4f979080a1e79f1a42b6e0e4fc7ff35c.svg";
export { ForwardRef as ReactComponent };